import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useLoadScript, Autocomplete } from '@react-google-maps/api';

const libraries = ["places"]; // Define libraries outside the component to avoid unnecessary reloads

const GooglePlacesAutocomplete = ({ onPlaceSelected, setZipCode, setAddress, label, disabled, className = '', placeholder = '' }) => {
    const autocompleteRef = useRef(null);
    const [inputValue, setInputValue] = useState('')

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyBk6F6JK68CJ-eY7tGLq45mbiju63EwUps',
        libraries // Pass libraries directly from the defined constant
    });

    const onLoad = useCallback((autocomplete) => {
        autocompleteRef.current = autocomplete;
    }, []);

    const onPlaceChanged = () => {
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();
      console.log('PLACE', place);
            onPlaceSelected(place);
        }
    };


    useEffect(() => {
        if (!isLoaded) return; // Wait until the Google Maps script is loaded
        if(!setZipCode) return
        if(!setAddress) return

        const autocompleteService = new window.google.maps.places.AutocompleteService();
        const placesService = new window.google.maps.places.PlacesService(document.createElement("div"));

        if (inputValue.trim()) {
            autocompleteService.getPlacePredictions({ input: inputValue }, (predictions, status) => {
                if (
                    status === window.google.maps.places.PlacesServiceStatus.OK &&
                    predictions?.length
                ) {
                    const placeId = predictions[0].place_id;

                    if (placeId) {
                        // Fetch full details of the place
                        placesService.getDetails({ placeId }, (placeDetails, detailsStatus) => {
                            if (
                                detailsStatus ===
                                window.google.maps.places.PlacesServiceStatus.OK &&
                                placeDetails
                            ) {
                                setAddress(placeDetails.formatted_address)
                                
                                const addressComponents = placeDetails.address_components;
                                
                                // Extract ZIP code from address components
                                const postalCodeComponent = addressComponents?.find((component) =>
                                    component.types.includes("postal_code")
                                );
                                

                                if (postalCodeComponent) {
                                    setZipCode(postalCodeComponent.long_name);
                                } else {
                                    setZipCode("");
                                }
                            }
                        });
                                
                                
                    }
                } else {
                    setZipCode("");
                }
            });
        } else {
            setZipCode("");
            console.log("");
        }
    }, [inputValue, isLoaded]);

    if (loadError) return "Error loading maps";
    if (!isLoaded) return null; // Return null while maps are loading

    return (
        <Autocomplete
            options={{
                componentRestrictions: {
                    country: 'us',
                    country: 'us',
                }
            }}
            onLoad={onLoad}
            onPlaceChanged={onPlaceChanged}
        >
            {label ?
                <>
                    <label>{label}</label>
                    <input
                        type="text"
                        className={className ? className : "w-full p-2 border border-gray-300 rounded focus:ring-brand focus:border-brand"}
                        disabled={disabled}
                        required
                        placeholder={placeholder}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                </>
                : (
                    <input
                        type="text"
                        className={className ? className : "w-full p-2 border border-gray-300 rounded focus:ring-brand focus:border-brand"}
                        disabled={disabled}
                        required
                        placeholder={placeholder}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                )}
        </Autocomplete>
    );
};

export default GooglePlacesAutocomplete;